<template>

    <div class="">

        <v-container class="verification-link">
      <v-layout row>
        <v-flex xs6 offset-xs3>
          <v-card class="border-all-1 corner-all-10 box_s d-flex">
            <v-card-text class="pl0">

              <v-text-field
                v-model="password"
                label="Enter Your Password"
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                v-validate="{required:true}"
                data-vv-name="code"
                :error-messages="errors.collect('password')"
              ></v-text-field>

            </v-card-text>
            <v-card-actions class="pl0">
              <vue-recaptcha id="recaptcha" ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" :sitekey="recaptchaSiteKey" size="invisible">
                <v-btn class="proceed-btn" color="primary" :disabled="!password" :loading="loader">Confirm</v-btn>
              </vue-recaptcha>
              
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    </div>
    
</template>

<script>

import VueRecaptcha from 'vue-recaptcha'
import helpers from '../services/toast-service'

export default {
  name: 'taxCategoryUpdate',
  mixins: [helpers],
  components: { VueRecaptcha },
  data () {
    return {
      color: '',
      message: '',
      password: '',
      showPassword: false,
      recaptcha_response: '',
      loader: false
    }
  },
  computed: {
    recaptchaSiteKey () {
      return JSON.parse(localStorage.getItem('ApiculusEnv')).siteKey
    }
  },
  methods: {
    onCaptchaVerified (res) {
      if (res && res.length) {
        this.recaptcha_response = res
        this.updateTaxCategory()
      } else {
        this.toastAlert('Error in verifying the reCAPTCHA', 'error')
      }
    },
    onCaptchaExpired (res) {
      this.recaptcha_response = ''
      this.$refs.recaptcha.reset()
    },
    proceed () {
      this.$refs.recaptcha.execute()
    },
    updateTaxCategory () {
      if (this.password && this.password.length && this.recaptcha_response) {
        this.loader = true
        let payload = {
          id: this.$route.query.id,
          password: this.password,
          'g-recaptcha-response': this.recaptcha_response
        }

        this.$store.dispatch('ACTION_UPDATE_TAX_CATEGORY', payload).then((res) => {
          console.log(res)
          this.loader = false
          if (res && res.data && res.data.success) {
            this.toastAlert('Tax Category successfully updated!', 'success')
            setTimeout(() => {
              this.$router.push('/')
            }, 3000)
          } else {
            this.toastAlert(res.error.internalMessage || res.error.message || 'Verification link invalid/expired.', 'error')
            this.recaptcha_response = ''
            this.$refs.recaptcha.reset()
            setTimeout(() => {
              this.alert = false
              this.color = ''
              this.message = ''
            }, 3000)
          }
        })
      }
    }
  },
  created () {
    console.log('inside tax category')
    console.log(this.$route.query)
  }
}
</script>


<style lang="scss">
  .verification-link {
    margin-top: 20vh
  }
  .d-flex {
    display: flex !important;
  }
  .proceed-btn {
    background-color: var(--col-primary) !important
  }
</style>
